// extracted by mini-css-extract-plugin
export var acitonButtons = "_h9-0";
export var additionalIcon = "_h9-f";
export var block = "_h9-1";
export var blockContent = "_h9-7";
export var blockDescription = "_h9-8";
export var blockIcon = "_h9-9";
export var blockTitle = "_h9-6";
export var border = "_h9-a";
export var center = "_h9-l";
export var edge = "_h9-b";
export var edgeLabel = "_h9-c";
export var edgePath = "_h9-d";
export var error = "_h9-e";
export var flowchart = "_h9-g";
export var flowchartContent = "_h9-h";
export var highlighted = "_h9-3";
export var hover = "_h9-4";
export var icon = "_h9-i";
export var left = "_h9-m";
export var navButton = "_h9-j";
export var navButtons = "_h9-k";
export var right = "_h9-n";
export var selected = "_h9-2";
export var small = "_h9-5";